import React, { useState, useEffect, useRef } from 'react';
import Chart from "react-apexcharts";

import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import SegmentedControl from '../SegmentedControl/SegmentedControl';
import { copyToClipboard, fixDate } from '../../helpers/helperFunctions';
import ExtendedInfoGraph from '../Graphs/ExtendedInfoGraph';


const ExtendedInfoModal = ({show, type, data, onClose, turnOffStolenMode}) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [info, setInfo] = useState({title: "battery_title", copy: "battery_copy", icon: "battery_full"})
    const [visibleInfo, setVisibleInfo] = useState({})
    const [modalType, setModalType] = useState()
    const [graphInfo, setGraphInfo] = useState({})
    const [copySuccess, setCopySuccess] = useState(false)
    
    useEffect(() => {
        typeRender()
    }, [type])

    useEffect(() => {
        if(data?.data){
            let lastPoint = data.data[data?.data?.length-1]
            setGraphInfo({points: data?.data, unit: data?.unit})
            setVisibleInfo(lastPoint)
        }
    }, [data])

    const clicky = (clickedData) => {
        if(clickedData?.servertime){
            setVisibleInfo(clickedData)

        }
    }

    const handleClose = () => {
        setModalType(null)
        onClose()
    }

    const copyLink = (url) => {
        copyToClipboard(url).then((result) => {
            setCopySuccess(true)
            setTimeout(() => {
                setCopySuccess(false)
            }, 1000);
		})
		.catch((error) => {
			console.log("Copy failed:", error); // trigger failure action
		});
    }

    const graphModal = () => {
        return (
            <>
            <div className="d-flex flex-row p-3 justify-content-between border-settings align-items-center">
                <div className='d-flex align-items-center'>
                    <img src={info.icon} className={info.rotate ? "rotate-270" : ""} alt=""/>
                    <h3 className="ms-2">{t(`extended_info.${info.title}`)}</h3>
                </div>
                <img className="cursor-pointer" src={icons.close_gray} onClick={() => handleClose()} alt="..." /> 
            </div>
            <div className="d-flex flex-column p-3">
                <p className="thin dark-grey">{t(`extended_info.${info.copy}`)}</p>
                <div className="d-flex justify-content-around align-items-center mt-3">
                    {data?.data?.length === 0
                        ?
                        <>
                        <p className="thin dark-grey">{t("extended_info.no_history")}</p>
                        </>
                        :
                        <>
                        <div className="detail_container d-flex flex-column border-12 p-3 align-items-center w-50 me-2">
                            <p className="bold">{fixDate(visibleInfo?.servertime, true)}</p>
                        </div>
                        <div className="detail_container d-flex flex-row border-12 p-3 align-items-center w-50 justify-content-around ms-2">                    
                                {type === "temp" || type === "humidity" ?
                                    <>
                                        <p className="bold">
                                            H: {visibleInfo?.value_highest != null ? (visibleInfo?.value_highest).toFixed(1) : "--"}{graphInfo.unit ?? "%"}
                                        </p>
                                        <p className="bold">
                                            L: {visibleInfo?.value_lowest != null ? (visibleInfo?.value_lowest).toFixed(1) : "--"}{graphInfo.unit ?? "%"}
                                        </p>
                                    </>
                                    : type === "battery"
                                    ?
                                    <p className="bold">{(visibleInfo?.value)?.toFixed(1)}{graphInfo?.unit ?? "%"}</p>
                                    :
                                    <p className="bold">{((visibleInfo?.value))?.toFixed(2)}{graphInfo?.unit ?? "%"}</p>
                                }

                        </div>
                        </>
                    }
                    
                </div>
                <ExtendedInfoGraph type={type} data={graphInfo} setClickedData={(clickedData) => clicky(clickedData)} />
            </div>

            </>
        )
    }

    const dataplanModal = () => {
        return (
            <>
            <div className="d-flex flex-row p-3 justify-content-between border-settings align-items-center">
                <div className='d-flex align-items-center'>
                    <img src={info.icon} alt=""/>
                    <h3 className="ms-2">{t(`extended_info.${info.title}`)}</h3>
                </div>
                <img className="cursor-pointer" src={icons.close_gray} onClick={() => handleClose()} alt="..." /> 
            </div>
            <div className="d-flex flex-column p-3">
                <p className="thin dark-grey">{t(`extended_info.${info.copy}`)}</p>
                <div className="d-flex flex-column justify-content-around align-items-center mt-3">
                    <div className="detail_container d-flex flex-column border-12 p-3 align-items-center w-100">
                        <p className="bold">{"Boost"}</p>
                        <p className="thin dark-grey">{t("extended_info.current_dataplan")}</p>
                    </div>
                    {true &&
                        <div className="d-flex flex-row justify-content-around align-items-center mt-3 w-100">
                            <div className="detail_container d-flex flex-column border-12 p-3 align-items-center w-50 me-2">
                                <p className="bold">{"Boost"}</p>
                                <p className="thin dark-grey">{t("extended_info.next_payment")}</p>
                            </div>
                            <div className="detail_container d-flex flex-column border-12 p-3 align-items-center w-50 ms-2">
                                <p className="bold">{"Boost"}</p>
                                <p className="thin dark-grey">{t("extended_info.status")}</p>
                            </div>
                        </div>
                    }
                    <div className="detail_container d-flex flex-column border-12 p-3 align-items-center w-100 mt-3">
                        <p className="bold">{"Boost"}</p>
                        <p className="thin dark-grey">{t("extended_info.region_coverage")}</p>
                    </div>
                </div>
            </div>

            </>
        )
    }

    const stolenModeModal = () => {
        return (
            <>
            <div className="d-flex flex-row p-3 justify-content-between border-settings align-items-center">
                <div className='d-flex align-items-center'>
                    <img src={info.icon} alt=""/>
                    <h3 className="ms-2">{t(`extended_info.${info.title}`)}</h3>
                </div>
                <img className="cursor-pointer" src={icons.close_gray} onClick={() => handleClose()} alt="..." /> 
            </div>
            <div className="d-flex flex-column p-3">
                <p className="thin dark-grey mb-3">{t(`extended_info.${info.copy}`)}</p>
                <form>
                    <div className="form-group d-flex align-items-center position-relative">
                        <input
                            type={"text"}
                            className="form-control bg-light-grey p-2 pe-5"
                            id="text"
                            value={data?.url ?? ""}
                            placeholder=""
                            readOnly={true}
                        />
                        <img src={copySuccess ? icons.radio_checked : icons.copy} onClick={() => copyLink(data?.url)} className={`${copySuccess ? "": "inp-link-icon"} position-absolute size_15 ms-2 cursor-pointer end-0 me-2`} alt="" />
                    </div>
                </form>
            </div>
            <div className="d-flex flex-row p-3 justify-content-end border-settings-top align-items-center">
               <Button onClick={() => handleClose()} btnClass="btn-secondary me-2">{t("settings.cancel")}</Button>
               <Button onClick={() => turnOffStolenMode("")} btnClass={`btn-danger`}>{t("extended_info.turn_off")}</Button>
            </div>
            </>
        )
    }


    const typeRender = () => {
        switch(type){
            case "temp":
                setModalType("graph")
                setInfo({title: "temp_title", copy: "temp_copy", icon: icons.temperature})
            break;
            case "humidity":
                setModalType("graph")
                setInfo({title: "hum_title", copy: "hum_copy", icon: icons.humidity})
            break;
            case "battery":
                setModalType("graph")
                setInfo({title: "battery_title", copy: "battery_copy", rotate: true, icon: icons.battery_three_quarter})
            break;
            case "voltage":
                setModalType("graph")
                setInfo({title: "voltage_title", copy: "voltage_copy", icon: icons.volt})
            break;
            case "dataplan":
                setModalType("dataplan")
                setInfo({title: "dataplan_title", copy: "dataplan_copy", icon: icons.sidebar.card_active})
            break;
            case "stolenmode":
                setModalType("stolenmode")
                setInfo({title: "stolenmode_title", copy: "stolenmode_copy", icon: icons.stolenmode})
            break;
            default: return null
        }
    }

    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column">
                <div className="w-100 h-100">
                    {modalType === "graph" && data
                        ? graphModal()
                    : modalType === "dataplan" && data
                        ? dataplanModal()
                    : modalType === "stolenmode" && data
                        ? stolenModeModal()
                    : null
                    }
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default ExtendedInfoModal;